﻿export const initChangeAccountData = () => {
    const form = document.querySelector('[data-role="change-account-data-form"]');
    if (!form) return;

    const dialog = document.getElementById('personal-data-change-confirmation');

    form.addEventListener('submit', (event) => {
        // Submit komt vanuit de Yes/No knop in de dialog → gewoon door laten.
        if (event.submitter?.name === 'AlsoUpdatePersonalData') {
            event.submitter.setAttribute('loading', '');
            return;
        }

        // Geen dialog aanwezig → normale submit met loading state.
        if (!dialog || !window.dialog) {
            event.submitter?.setAttribute('loading', '');
            return;
        }

        // Dialog vragen, form nog niet submitten.
        event.preventDefault();
        window.dialog.open({
            elemId: 'personal-data-change-confirmation',
            dismissable: false,
        });
    });
};